module.exports = __webpack_public_path__ + "assets/pkd_charity.5b8131007d4c777ac35e5ef99b8b9a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pkd_charity.jpg
// module id = 334
// module chunks = 0